import { CourseCompletionStatus } from '../trackingClient';

const scormWrapper = require('./scorm.js');

export interface ScormClient {
  init: () => void;
  connection: {
    isActive: boolean;
  };
  get: (key: string) => string;
  set: (key: string, value: string) => void;
  status: (action: string, value?: string) => CourseCompletionStatus;
  save: () => void;
  quit: () => void;
}

export const scormClient: ScormClient = scormWrapper.pipwerks.SCORM;
